import { render, staticRenderFns } from "./talentEdit.vue?vue&type=template&id=7ef47df3&scoped=true"
import script from "./talentEdit.vue?vue&type=script&lang=js"
export * from "./talentEdit.vue?vue&type=script&lang=js"
import style0 from "./talentEdit.vue?vue&type=style&index=0&id=7ef47df3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef47df3",
  null
  
)

export default component.exports